import { print } from 'graphql';
import { MUTATION_UPLOAD_PROJECT_ANALYSIS_REPORT_HTML } from '@/graphql/mutation/projectAnalysis';

function getGraphqlHttpUrl(): string {
  const base = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/+$/, '') || '';
  const withoutGraphql = base.endsWith('/graphql') ? base.slice(0, -'/graphql'.length) : base;
  return `${withoutGraphql.replace(/\/+$/, '')}/graphql`;
}

export async function uploadProjectAnalysisReportHtmlMultipart(
  reportId: string,
  file: File,
  idToken: string
): Promise<void> {
  const url = getGraphqlHttpUrl();
  if (!url || url === '/graphql') {
    throw new Error('API URL is not configured');
  }

  const operations = JSON.stringify({
    query: print(MUTATION_UPLOAD_PROJECT_ANALYSIS_REPORT_HTML),
    variables: {
      report_id: reportId,
      file: null,
    },
  });

  const map = JSON.stringify({ '0': ['variables.file'] });

  const formData = new FormData();
  formData.append('operations', operations);
  formData.append('map', map);
  const filename = file instanceof File ? file.name : 'report.html';
  formData.append('0', file, filename);

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Apollo-Require-Preflight': 'true',
    },
    body: formData,
  });

  const result: { errors?: { message: string }[]; data?: unknown } = await response.json();

  if (!response.ok) {
    throw new Error(result.errors?.[0]?.message || `Upload failed (${response.status})`);
  }

  if (result.errors?.length) {
    throw new Error(result.errors[0].message);
  }
}
